
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
if (this.$route.params.ItemVersion.CPV_Date !== '') {
this.list = [{
label: '监管证件名称',
value: this.$route.params.Item.PRD_Name
}, {
label: '监管证件说明',
value: this.$route.params.Item.PRD_Remark
}]
} else {
this.list = [{
label: '监管证件名称',
value: this.$route.params.Item.PRD_Name
}, {
label: '监管证件说明',
value: this.$route.params.Item.PRD_Remark
}]
}
}
}



// WEBPACK FOOTER //
// ./src/components/RegulatoryDocDetail_Item.vue